// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Messages extends APIResource {
    /**
     * List messages for a given step.
     */
    list(stepID, query = {}, options) {
        return this._client.getAPIList(path `/v1/steps/${stepID}/messages`, (ArrayPage), {
            query,
            ...options,
        });
    }
}
//# sourceMappingURL=messages.mjs.map